export const listProviders = state => state.providers.allProviders;

export const showProvider = (state, providerId) => state.providers.allProviders.find(t => t.id === providerId);

export const getTotalCount = state => state.providers.totalCount;

export const listProvidersFilters = state => state.providers.filters;
